var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrived(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 4,
    fill: "#04B7B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 7.5C13.8284 7.5 14.5 6.82845 14.5 6C14.5 5.17158 13.8284 4.5 13 4.5C12.1715 4.5 11.5 5.17158 11.5 6C11.5 6.82845 12.1715 7.5 13 7.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5C12.4477 5 12 5.44772 12 6C12 6.5523 12.4477 7 13 7C13.5523 7 14 6.5523 14 6C14 5.44772 13.5523 5 13 5ZM11 6C11 4.89543 11.8954 4 13 4C14.1045 4 15 4.89543 15 6C15 7.10455 14.1045 8 13 8C11.8954 8 11 7.10455 11 6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12.65C16 11.8145 15.6839 11.0133 15.1213 10.4226C14.5587 9.83185 13.7957 9.5 13 9.5C12.2043 9.5 11.4413 9.83185 10.8787 10.4226C10.3161 11.0133 10 11.8145 10 12.65V14H11.2857L11.7143 18.5H14.2857L14.7143 14H16V12.65Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5166 10.0778C11.1709 9.3908 12.0637 9 13 9C13.9363 9 14.8291 9.3908 15.4834 10.0778C16.1369 10.7639 16.5 11.6896 16.5 12.65V14C16.5 14.2761 16.2761 14.5 16 14.5H15.169L14.7835 18.5474C14.759 18.804 14.5435 19 14.2857 19H11.7143C11.4565 19 11.241 18.804 11.2165 18.5474L10.831 14.5H10C9.72385 14.5 9.5 14.2761 9.5 14V12.65C9.5 11.6896 9.8631 10.7639 10.5166 10.0778ZM13 10C12.345 10 11.7117 10.273 11.2408 10.7675C10.7691 11.2628 10.5 11.9395 10.5 12.65V13.5H11.2857C11.5435 13.5 11.759 13.696 11.7835 13.9526L12.169 18H13.831L14.2165 13.9526C14.241 13.696 14.4565 13.5 14.7143 13.5H15.5V12.65C15.5 11.9395 15.2309 11.2628 14.7592 10.7675C14.2883 10.273 13.655 10 13 10Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 8V12H4V8H5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 9.5H8V10.5H4V9.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V12H21V8H22Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9.5H22V10.5H18V9.5Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06585 15.3438C8.1522 15.6061 8.00955 15.8887 7.74725 15.975C6.83795 16.2744 6.12835 16.64 5.65628 17.0306C5.1817 17.4232 5 17.7933 5 18.1132C5 18.3983 5.14297 18.721 5.51084 19.0675C5.87968 19.415 6.44035 19.751 7.1747 20.0436C8.6406 20.6277 10.7 21.0001 13 21.0001C15.3 21.0001 17.3594 20.6277 18.8253 20.0436C19.5597 19.751 20.1203 19.415 20.4891 19.0675C20.857 18.721 21 18.3983 21 18.1132C21 17.7933 20.8183 17.4232 20.3437 17.0306C19.8717 16.64 19.1621 16.2744 18.2528 15.975C17.9904 15.8887 17.8478 15.6061 17.9342 15.3438C18.0205 15.0815 18.3032 14.9388 18.5655 15.0252C19.5439 15.3473 20.3797 15.7625 20.9812 16.2601C21.5801 16.7557 22 17.3814 22 18.1132C22 18.7633 21.6672 19.3316 21.1749 19.7954C20.6835 20.2584 19.9993 20.6522 19.1954 20.9725C17.5849 21.6143 15.3943 22.0001 13 22.0001C10.6057 22.0001 8.41505 21.6143 6.80455 20.9725C6.0007 20.6522 5.31656 20.2584 4.82513 19.7954C4.33274 19.3316 4 18.7633 4 18.1132C4 17.3814 4.41987 16.7557 5.0188 16.2601C5.62023 15.7625 6.4561 15.3473 7.43455 15.0252C7.69685 14.9388 7.9795 15.0815 8.06585 15.3438Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrived);
export default __webpack_public_path__ + "static/media/Arrived.91d7facff9b90a1c1971a3f620eafb40.svg";
export { ForwardRef as ReactComponent };